'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default =

function ($sce) {
    "ngInject";
    return function (input) {
        return $sce.trustAsHtml(input || '');
    };
};

;


// WEBPACK FOOTER //
// ./app/base/filters/trust.js